import { Flex, Heading, Skeleton, Text, Image } from '@chakra-ui/react';
import { Races, Rarity } from 'api/generated/graphql';
import { RaceStatus } from 'types';
import TournamentBadge from 'components/Tiers/TournamentBadge';
import IconKgen from 'components/IconKgen/IconKgen';
import RaceLevel from 'components/Races2/RaceLevel/RaceLevel';
import { trackFlags } from 'components/Accordions/TrackAccordion/TrackAccordion';
import GridCounter from 'components/GridCounter/GridCounter';
import { CountdownTimer } from 'components/CountdownTimer/CountdownTimer';
interface RaceHeaderProps {
  race?: Races;
  raceStatus: RaceStatus;
}

export const raceRarity: Record<0 | 1 | 2 | 3 | 4 | 5, string> = {
  0: 'free',
  1: Rarity.Common,
  2: Rarity.Uncommon,
  3: Rarity.Rare,
  4: Rarity.Epic,
  5: Rarity.Legendary,
};

export const RaceHeader = ({ race, raceStatus }: RaceHeaderProps) => {
  return (
    <Flex
      w={{ base: 'full', md: '38rem' }}
      alignItems="flex-end"
      justifyContent={{ base: 'center', md: 'space-between' }}
      gap={{ base: '7', md: '4' }}
      flexDir="row"
      mb="0.5rem"
    >
      <Flex
        alignItems="flex-start"
        flexDir="column"
        gap="2"
      >
        <Flex
          alignItems="center"
          gap="2"
        >
          {race?.track?.frontendName ?
            <Image 
              src={`/images/flags/${trackFlags[race?.track?.frontendName || '']}`}
              alt={`${race?.track?.frontendName} Flag`}
              width={{ base: '22px', md: '30px' }}
              height={{ base: '16px', md: '24px' }}
            />
          : <Skeleton height="24px" width="30px" />}
          <Heading fontSize={{ base: '1.25rem', md: '1.5rem' }} lineHeight="1.5rem" fontWeight={400}>
            {race?.track?.frontendName || (
              <Skeleton height="1rem" width="7rem" />
            )}
          </Heading>
        </Flex>
        
        <Flex
          fontFamily="body"
          gap="2"
        >
          {race?.tier.name.toLowerCase() === 'tournament' || race?.tier.name.toLowerCase() === 'weeklytournament' ? (
            <TournamentBadge type={race?.tier.name.toLowerCase() === 'tournament' ? 'daily' : 'weekly'} />
          ) 
          : race?.tier.name.toLowerCase() === 'kgen' ? (
              <IconKgen />
            ) 
            : (
              <RaceLevel level={(race?.difficulty || 0) + 1} isRaceLevel />
            )}
          <GridCounter participants={race?.playersParticipants.length || 0} />
        </Flex>
      </Flex>

      <Flex
        fontFamily="body"
        textTransform="none"
        gap="1"
        mr="-2rem"
        pb="1"
        alignItems="center"
      >
        <Text
          fontSize={{ base: '12px', md: '14px' }}
          lineHeight={{ base: '14px', md: '18px' }}
          fontWeight="500"
          color="treasuredTeal.100"
          textTransform="uppercase"
        >
          ENTRIES CLOSE IN
        </Text>

        <CountdownTimer timeLeft={race?.qualifyingAnnouncementTime || ''} />
      </Flex>
    </Flex>
  );
};